import React, { FC, ReactElement, useState } from "react";
import AIModal from "../../elements/AIModal";
import { default as arrow} from "../../../AE2/static/icons/needs_attention/Side Arrow.svg"
import { IonButton, IonChip, IonIcon, IonItem, IonLabel, IonList } from "@ionic/react";
import { API_URL } from "../../../actions/settings";
import LoadingDots from "../../extras/LoadingDots";
import { chevronDownCircle, chevronUpCircle } from "ionicons/icons";

async function getData(token: string, id: string) {
  return fetch(`${API_URL}/homepage/needs_attention/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                console.log(err)
                return null
            })

        }
      }).catch(error => {
        console.log(error)
        return null
      });
}

interface IProps {
    id: string;
    title: ReactElement;

};

interface DataItem {
    id: string;
    type:string;
    building: string;
    customer?: string;
    detail:string;
 
}

function sortByKey<T>(array: T[], key: keyof T, direction: 'asc' | 'desc' = 'asc'): T[] {
    return [...array].sort((a, b) => {
        const valA = getSortableValue(String(a[key]));
        const valB = getSortableValue(String(b[key]));

        const res = 
        typeof valA === 'string' && typeof valB === 'string' ? valA.localeCompare(valB)
        : valA > valB ? 1 : valA < valB ? -1 : 0;

        return direction === 'asc' ? res : -res;
        })        
    }

function getSortableValue(value:string|number): number | string {
    const str =  String(value)

    //check m/yyyy format
    if(/^\d{1,2}\/\d{4}$/.test(str)){
        const [month, year] = str.split('/').map(Number);
        return year*100 + month
    }

    if(!isNaN(Number(str))){
        return Number(str)        
    }

    return str.toLocaleLowerCase()
}

const NeedsAttentionModal:FC<IProps> = (props) => {
    const [opened, setOpened] = useState(false)
    const [data, setData] = useState<null|DataItem[]>(null)
    const [loading,setLoading] = useState(true)
    const [sortBy, setSortBy] = useState<any>('building')
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc')
    
    const handleData = async () => {
        if(!data){
            setLoading(true)
            const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
            const res = await getData(token, props.id)
            if(!res){
                setData(null)
                setLoading(false)
            }
            setData(res.data)
            setLoading(false)
        }
    }



    const handleSort = (key: keyof DataItem) => {
        if (data) {
            // Toggle direction if same key is clicked
            const newDirection = sortBy === key && sortDirection === 'asc' ? 'desc' : 'asc';
            setSortBy(key);
            setSortDirection(newDirection);
            const sortedData = sortByKey(data, sortBy, newDirection);
            setData(sortedData)
        }
    }
    
    const detailTitle = () =>{
        switch(props.id){
            case 'old_benchmarks':
                return 'Date'
            case 'low_score':
                return 'Score'
            case 'warranties_expiring':
                return 'Date'
            default:
                return 'Detail'
        }
    }




    

    return  <div>
        <IonButton fill="clear" slot="end" onClick={()=>setOpened(true)}>
        <IonIcon className="pointer" src={arrow} />
        </IonButton>
        <AIModal title={props.title} opened = {opened} setOpened={setOpened} onLoad={()=>handleData()} >
            <div style={{width:'100%',textAlign:'center'}}>
                {loading ? 
                <div>
                    <LoadingDots/>
                </div> :
                <div>
                    <div style={{'marginBottom':'0.2rem'}}>
                        <div>Sort By:</div>
                        <IonChip onClick={()=>handleSort('building')}>
                            <IonLabel>
                                Building
                            </IonLabel>
                            {sortBy === 'building' && <IonIcon src={ sortDirection === 'asc' ? chevronUpCircle : chevronDownCircle} />}                                           
                        </IonChip>                        
                        <IonChip onClick={()=>handleSort('customer')}>
                            <IonLabel>
                                Customer
                            </IonLabel>
                            {sortBy === 'customer' && <IonIcon src={ sortDirection === 'asc' ? chevronUpCircle : chevronDownCircle}  />}                                           
                        </IonChip>
                        <IonChip onClick={()=>handleSort('detail')}>
                            <IonLabel>
                                {
                                    detailTitle()
                                }
                            </IonLabel>
                            {sortBy === 'detail' && <IonIcon src={ sortDirection === 'asc' ? chevronUpCircle : chevronDownCircle} />}                                           
                        </IonChip>
                    </div>
                    {data?.length && data?.length > 0 ? 
                    <IonList>
                        {data.map((item: DataItem) => (
                            <IonItem  key={item.id} href={`/?id=${item.id}&sec=${item.type}`}>
                                <IonLabel><div>
                                        <div>{item.building} ({item.detail})</div>
                                        <div className="text-footer-blue font-11pt">{item.customer}</div>
                                    </div>
                                    </IonLabel>
                                    <IonIcon className="pointer" src={arrow}/>                                
                            </IonItem>
                        ))}
  
                    </IonList>: <div>None</div>}
                </div>
                }
            </div>
        </AIModal>
    </div>
};

export default NeedsAttentionModal;